import type { WithToggleChildrenProps, WithToggleProps } from 'components/shared/WithToggle/WithToggle';
import { WithToggle } from 'components/shared/WithToggle/WithToggle';
import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';
import type { RenderPropChildren } from 'types/children';

export interface ModalAnchorTriggerBaseProps {
  id: string;
  text: IntlKey | string;
  className?: string;
  e2e?: string;
}

export type ModalAnchorTriggerChildrenProps = RenderPropChildren<WithToggleChildrenProps & { e2e?: string }>;

export type ModalAnchorTriggerProps = ModalAnchorTriggerBaseProps &
  Omit<WithToggleProps, 'isInitiallyOn'> &
  ModalAnchorTriggerChildrenProps;

export const ModalAnchorTrigger: FC<ModalAnchorTriggerProps> = ({ id, text, className, children, e2e }) => {
  const intl = useIntl();

  return (
    <WithToggle>
      {toggleProps => (
        <>
          <a
            id={id}
            data-e2e={e2e ?? id}
            className={className ?? defaultClassName}
            role="button"
            onClick={toggleProps.toggleOn}
          >
            {intl.formatMessage({ id: text as IntlKey })}
          </a>
          {children({ ...toggleProps, e2e })}
        </>
      )}
    </WithToggle>
  );
};

ModalAnchorTrigger.displayName = 'ModalAnchorTrigger';

const defaultClassName = 'text-danger text-link fw-bold';
